import { useDocumentTitle } from '../common';
import { RequestStatus } from '../request-status';
import { useApproverRequests } from '../team';

export const Approval = ({ title }: { title: string }) => {
  useDocumentTitle({ title });

  const { requests, apiCallStatus } = useApproverRequests();

  return apiCallStatus === null ? (
    <span>Loading...</span>
  ) : apiCallStatus === false ? (
    <span>Error to get requests to approve.</span>
  ) : apiCallStatus === true && requests.length === 0 ? (
    <span>You have no requests to approve.</span>
  ) : (
    <RequestStatus
      requests={requests}
      requestStatusType="MemberRequestApproval"
    />
  );
};
